import LessonPage from "../../../../components/LessonPage";

export default function OlumPage() {
  const sections = [
    {
      label: "علوم",
      points: 120,
      items: [
        { title: "درس 1", icon: "📘", link: "/classroom/class1/olum/lesson1/review1", image: "/img1.png" },
        { title: "درس 2", icon: "📘", link: "/classroom/class1/olum/lesson1/review2", image: "/img2.png" },
        { title: "درس 3", icon: "📘", link: "/classroom/class1/olum/lesson1/review3", image: "/img1.png" },
        { title: "درس 4", icon: "📘", link: "/classroom/class1/olum/lesson1/review4", image: "/img1.png" },
        { title: "درس 5", icon: "📘", link: "/classroom/class1/olum/lesson1/review5", image: "/img2.png" },
        { title: "درس 6", icon: "📘", link: "/classroom/class1/olum/lesson1/review6", image: "/img1.png" },
        { title: "درس 7", icon: "📘", link: "/classroom/class1/olum/lesson1/review7", image: "/img1.png" },
        { title: "درس 8", icon: "📘", link: "/classroom/class1/olum/lesson1/review8", image: "/img2.png" },
        { title: "درس 9", icon: "📘", link: "/classroom/class1/olum/lesson1/review9", image: "/img1.png" },
        { title: "درس 10", icon: "📘", link: "/classroom/class1/olum/lesson1/review10", image: "/img1.png" },
        { title: "درس 11", icon: "📘", link: "/classroom/class1/olum/lesson1/review11", image: "/img2.png" },
        { title: "درس 12", icon: "📘", link: "/classroom/class1/olum/lesson1/review12", image: "/img1.png" },
        { title: "درس 13", icon: "📘", link: "/classroom/class1/olum/lesson1/review13", image: "/img1.png" },
        { title: "درس 14", icon: "📘", link: "/classroom/class1/olum/lesson1/review14", image: "/img2.png" },
        { title: "درس 15", icon: "📘", link: "/classroom/class1/olum/lesson1/review15", image: "/img1.png" },
      ],
    },
  ];

  return (
    <LessonPage
      title="علوم کلاس اول"
      sections={sections}
      onClose={() => window.history.back()}
    />
  );
}